import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

import { listen } from 'lib/eventManager';

export const OPEN_DIALOG_EVENT = 'open-dialog';

const DialogRoot = () => {
  const router = useRouter();
  const [Dialog, setDialog] = useState(null);

  const hideDialog = () => {
    setDialog(null);
  };

  useEffect(() => {
    router.events.on('routeChangeStart', hideDialog);

    const unlisten = listen(OPEN_DIALOG_EVENT, ({ detail }) => {
      hideDialog();

      // Small delay to ensure state is cleared before setting a new one
      setTimeout(() => {
        setDialog(detail);
      }, 0);
    });

    return () => {
      unlisten();
      router.events.off('routeChangeStart', hideDialog);
    };
  }, []);

  const onClose = () => {
    if ('onClose' in Dialog.props) {
      Dialog.props.onClose();
    }

    hideDialog();
  };

  if (!Dialog) {
    return null;
  }

  return <Dialog.component {...Dialog.props} onClose={onClose} />;
};

export default DialogRoot;
